module.exports = __webpack_public_path__ + "static/media/news-nem-president.891834ff.jpg";